import React from 'react';

const SidebarLeft = ({ activeCategory, setActiveCategory, activeFilter, setActiveFilter }) => {
  
  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    // Clear category when selecting a browse filter (except for "home" which shows all)
    if (filter === 'home') {
      setActiveCategory(null);
    }
  };

  const handleCategoryClick = (category) => {
    // Toggle category - if clicking the same category, clear it
    if (activeCategory === category) {
      setActiveCategory(null);
    } else {
      setActiveCategory(category);
    }
  };

  return (
    <aside className="sidebar-left">
      <div className="sidebar-section">
        <div className="sidebar-title">Browse</div>
        <nav className="sidebar-nav">
          <button 
            className={`sidebar-link ${activeFilter === 'home' && !activeCategory ? 'active' : ''}`}
            onClick={() => handleFilterClick('home')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            Home
          </button>
          <button 
            className={`sidebar-link ${activeFilter === 'popular' ? 'active' : ''}`}
            onClick={() => handleFilterClick('popular')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
            Popular
          </button>
          <button 
            className={`sidebar-link ${activeFilter === 'recent' ? 'active' : ''}`}
            onClick={() => handleFilterClick('recent')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            Recent
          </button>
          <button 
            className={`sidebar-link ${activeFilter === 'saved' ? 'active' : ''}`}
            onClick={() => handleFilterClick('saved')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
            </svg>
            Saved
          </button>
        </nav>
      </div>
      
      <div className="sidebar-section">
        <div className="sidebar-title">Categories</div>
        <nav className="sidebar-nav" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <button 
            className={`sidebar-link ${activeCategory === 'machine-learning' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('machine-learning')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
            </svg>
            Machine Learning
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'web-dev' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('web-dev')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="16 18 22 12 16 6"/>
              <polyline points="8 6 2 12 8 18"/>
            </svg>
            Web Dev
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'frontend' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('frontend')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <path d="M3 9h18"/>
            </svg>
            Frontend
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'backend' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('backend')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="8" rx="2"/>
              <rect x="2" y="14" width="20" height="8" rx="2"/>
              <line x1="6" y1="6" x2="6.01" y2="6"/>
              <line x1="6" y1="18" x2="6.01" y2="18"/>
            </svg>
            Backend
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'systems' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('systems')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="3" width="20" height="14" rx="2"/>
              <line x1="8" y1="21" x2="16" y2="21"/>
              <line x1="12" y1="17" x2="12" y2="21"/>
            </svg>
            Systems
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'databases' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('databases')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <ellipse cx="12" cy="5" rx="9" ry="3"/>
              <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
              <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
            </svg>
            Databases
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'algorithms' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('algorithms')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
            Algorithms
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'statistics' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('statistics')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 3v18h18"/>
              <path d="M7 16l4-8 4 5 5-6"/>
            </svg>
            Statistics
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'mathematics' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('mathematics')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
              <path d="M5 5l14 14"/>
            </svg>
            Mathematics
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'data-science' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('data-science')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
            </svg>
            Data Science
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'devops' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('devops')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
            DevOps
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'cloud' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('cloud')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
            </svg>
            Cloud
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'security' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('security')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            Security
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'cryptography' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('cryptography')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            Cryptography
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'computer-vision' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('computer-vision')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
            Computer Vision
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'nlp' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('nlp')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            NLP
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'blockchain' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('blockchain')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="7" width="6" height="6"/>
              <rect x="16" y="7" width="6" height="6"/>
              <rect x="9" y="2" width="6" height="6"/>
              <rect x="9" y="16" width="6" height="6"/>
              <path d="M12 8v8"/>
              <path d="M8 10h2"/>
              <path d="M14 10h2"/>
            </svg>
            Blockchain
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'mobile' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('mobile')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="5" y="2" width="14" height="20" rx="2"/>
              <line x1="12" y1="18" x2="12.01" y2="18"/>
            </svg>
            Mobile
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'networking' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('networking')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="5" r="2"/>
              <circle cx="12" cy="19" r="2"/>
              <circle cx="5" cy="12" r="2"/>
              <circle cx="19" cy="12" r="2"/>
              <line x1="12" y1="7" x2="12" y2="10"/>
              <line x1="12" y1="14" x2="12" y2="17"/>
              <line x1="7" y1="12" x2="10" y2="12"/>
              <line x1="14" y1="12" x2="17" y2="12"/>
            </svg>
            Networking
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'distributed-systems' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('distributed-systems')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="6" height="6" rx="1"/>
              <rect x="16" y="2" width="6" height="6" rx="1"/>
              <rect x="9" y="16" width="6" height="6" rx="1"/>
              <path d="M5 8v3a2 2 0 002 2h10a2 2 0 002-2V8"/>
              <line x1="12" y1="13" x2="12" y2="16"/>
            </svg>
            Distributed Systems
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'programming-languages' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('programming-languages')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 6.1H3"/>
              <path d="M21 12.1H3"/>
              <path d="M15.1 18H3"/>
            </svg>
            Languages
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'game-dev' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('game-dev')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="6" width="20" height="12" rx="2"/>
              <line x1="6" y1="12" x2="10" y2="12"/>
              <line x1="8" y1="10" x2="8" y2="14"/>
              <line x1="15" y1="11" x2="15" y2="11.01"/>
              <line x1="18" y1="13" x2="18" y2="13.01"/>
            </svg>
            Game Dev
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'api-design' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('api-design')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            API Design
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'testing' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('testing')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 11l3 3L22 4"/>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
            </svg>
            Testing
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'architecture' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('architecture')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M2 20h20"/>
              <path d="M5 20V8l7-5 7 5v12"/>
              <path d="M9 20v-6h6v6"/>
            </svg>
            Architecture
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'performance' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('performance')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
            </svg>
            Performance
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'career' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('career')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="7" width="20" height="14" rx="2"/>
              <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
            </svg>
            Career
          </button>
          <button 
            className={`sidebar-link ${activeCategory === 'general' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('general')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
              <line x1="9" y1="9" x2="9.01" y2="9"/>
              <line x1="15" y1="9" x2="15.01" y2="9"/>
            </svg>
            General
          </button>
        </nav>
      </div>
    </aside>
  );
};

export default SidebarLeft;

